<template>
  <section>
    <!-- Componentes externos -->
    <SolicitarEjecucionVacacion />
    <ModificarReprogramacion />
    <VerDetalle />
      <VerReporte />
    <h3 class="primary--text">
      <v-icon color="primary">business</v-icon> Reprogramación de vacaciones
    </h3>
    <v-card>
      <v-card-text>
        <crud-table
          :headers="headers"
          :url="url"
          :filters="filters"
          :data-graphql="dataGraphql"
          :graphql="graphql"
          :initData="initData"
        >
          <!-- Template injectable de la cabecera de la tabla -->

          <!-- Template de filas y columnas -->
          <template slot="items" slot-scope="items">
            <!-- Agregar las columnas que consideré necesarias -->
            <td class="text-xs-center">
              {{ items.item.secuencia }}
            </td>
            <td class="text-xs-center">{{ items.item.fecha_desde }}</td>
            <td class="text-xs-center">{{ items.item.fecha_hasta }}</td>
            <td class="text-xs-center">{{ items.item.total_dias }}</td>
            <td class="text-xs-center">{{ items.item.estado }}</td>
            <td>
              <!-- edicion de cronograma-->

              <v-btn
                color="#3dca24"
                @click.prevent="verDetalle(items.item)"
                icon
                title="Ver detalle"
              >
                <v-icon>remove_red_eye</v-icon>
              </v-btn>
                <!-- reprogramacion de cronograma-->
               <v-btn
                color="rgba(50,150,40,0.7)"
                @click.prevent="verReporte(items.item,1)"
                icon
                title="Ver reporte de reprogramación de vacación"
              >
                <v-icon>picture_as_pdf</v-icon>
              </v-btn>
              <!-- edicion de reprogramacion-->
              <!-- <v-btn
                v-if="items.item.id_estado == 68"
                color="blue"
                @click.native="modificarProgramacion(items.item)"
                icon
                title="Modificar"
              >
                <v-icon>edit</v-icon>
              </v-btn> -->

            </td>
          </template>
        </crud-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import CrudTable from "@/common/util/crud-table/CrudTable.vue"; // Componente Tabla Dinámica
import crud from "@/common/util/crud-table/mixins/crud-table"; // Funciones y Metodos
import SolicitarEjecucionVacacion from "./dialogs/SolicitarEjecucionVacacion.vue";
import VerDetalle from "./dialogs/VerDetalle.vue";
import ModificarReprogramacion from "./dialogs/ModificarReprogramacion.vue";
import VerReporte from "./dialogs/VerReporte";

export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [crud],
  // Variables iniciales del componente
  data() {
    let user = this.$storage.get("user");
    let id_persona = user.id_persona;
    return {
      url: "vVacacionReprogramadas",
      graphql: true,
      // Cabecera de la tabla
      headers: [
        // { text: 'Nombre de la cabecera', value: 'Campo que deseamos interpolar', align: 'center' },
        { text: "Nro", value: "secuencia", align: "center" },
        { text: "Fecha salida", value: "fecha_desde", align: "center" },
        { text: "Fecha fin", value: "fecha_hasta", align: "center" },
        { text: "Dias programados", value: "total_dias", align: "center" },
        { text: "Estado", value: "estado", align: "center" },
        { text: "Notificación", value: "", align: "center" },
        { text: this.$t("common.actions"), sortable: false, align: "center" }
      ],
      // Campos solicitados de Graphql(Agregar los que necesite)
      dataGraphql: `
        id
        fecha_desde
        fecha_hasta
        id_estado
        fecha_solicitud
        id_persona
        total_dias
        estado
        saldo_a_reprogramar
        gestion
        secuencia
      `,
      // Filtros del componente CrudTable ejemplo:
      // {
      // 	field: 'Campo definido en Graphql',
      // 	label: 'Etiqueta del input generado',
      // 	type: 'text', // Tipo de input en el filtro
      // 	typeG: 'String' // Tipo definido en Graphql
      // }
      initData: [
        {
          state: true,
          param: "id_persona",
          value: id_persona
        }
      ],
      filters: [
        {
          field: "secuencia",
          label: "Nro",
          type: "number",
          typeG: "Int"
        },
        // {
        //   field: "fecha_solicitud",
        //   label: "Fecha solicitud",
        //   type: "text",
        //   typeG: "String"
        // },
        {
          field: "fecha_desde",
          label: "Fecha salida",
          type: "text",
          typeG: "String"
        },
        {
          field: "fecha_hasta",
          label: "Fecha fin",
          type: "text",
          typeG: "String"
        },

        {
          field: "total_dias",
          label: "Dias",
          type: "number",
          typeG: "Float"
        },
        {
          field: "estado",
          label: "Estado",
          type: "text",
          typeG: "String"
        }
      ]
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }
    this.onFilter();
    this.$bus.$on("closeDialogVerDetalleRepFuncionario", () => {
     
    });
    this.$bus.$on("closeDialogSolicitarUsoVacacionFuncionario", () => {
      this.updateList();
    });
    this.$bus.$on("closeDialogModificarReprogramacion", () => {
      this.updateList();
    });
  },
  // Métodos y funciones del componente
  methods: {
    verReporte(item, valor) {
      item.reprogramacion = valor; //programacion=0,repro=1
      this.$bus.$emit("openDialogVerReporte", item);
    },
    solicitarEjecucionVacacion(item) {
      // item.funcionario = this.funcionario;
      // item.saldo = this.saldo;
      this.$bus.$emit("openDialogSolicitarEjecucionVacacion", item);
    },
    verDetalle(item) {
      this.$bus.$emit("openDialogVerDetalleRepFuncionario", item);
    },
    // Metodo para abrir dialog de modificacion
    modificarProgramacion(item) {
      this.$bus.$emit("openDialogModificarReprogramacion", item);
    }
  },
  // Definición de componentes importados
  components: {
    CrudTable,
    VerDetalle,
    SolicitarEjecucionVacacion,
    ModificarReprogramacion,
    VerReporte,

  }
};
</script>

<style>
h3 {
  color: rgb(2, 121, 95);
}
</style>



// WEBPACK FOOTER //
// src/components/admin/vacacion_reprogramacion/Funcionario.vue